<div class="create-wheel-modal" data-testid="create-wheel-modal-container">
  <div class="create-wheel-modal__content" data-testid="create-wheel-modal-content">
    <div class="create-wheel-modal__wheel-container">
      <wil-wheel
        [wheelId]="wheelId"
        type="professional"
        data-testid="create-wheel-modal-wheel"
      />
    </div>
  </div>

  <div class="create-wheel-modal__footer" data-testid="create-wheel-modal-footer">
    <button
      class="create-wheel-modal__button create-wheel-modal__button--secondary"
      type="button"
      (click)="onCancel()"
      data-testid="create-wheel-modal-cancel-button"
    >
      Close
    </button>
  </div>
</div>
